"use client";
import Image from 'next/image';
import React, { useState } from 'react';
import { Button } from '../ui/button';
import { motion, AnimatePresence } from 'framer-motion';
import AnimationContainer from "../utils/animation-container";

const BlurBox = () => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <div className='w-full h-full relative'>

            <AnimatePresence>
                {isHovered && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="fixed inset-0 backdrop-blur-sm bg-[#00000023] z-100"
                />
                )}
            </AnimatePresence>

            <AnimationContainer delay={0.5}>
                <motion.div
                    className=" bg-[url('/about-us-bg.gif')] bg-cover bg-no-repeat rounded-xl overflow-hidden"
                    onHoverStart={() => setIsHovered(true)}
                    onHoverEnd={() => setIsHovered(false)}
                >
                    <div className='w-full h-full bg-[#0e0b15c8] backdrop-blur-[3px] p-14 flex lg:flex-row flex-col lg:gap-0 gap-8'>
                        <div className='lg:w-7/12 w-full h-full flex flex-col gap-4'>
                            <h1 className='text-[25px] font-semibold'>بازی های محبوب</h1>
                            <p className='text-gray-400/90 text-[15px] text-justify'>
                                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد کتابهای زیادی در شصت و سه درصد گذشته حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد. و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد. و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.
                            </p>
                        </div>
                        <div className='lg:w-5/12 w-full h-full flex lg:justify-end justify-center relative'>
                            <div className='grid grid-cols-3 gap-6'>
                                <motion.div
                                    animate={{
                                        rotate: isHovered ? 0 : [4, 0, -4],
                                        scale: isHovered ? 0.8 : [1.1, 1.2]
                                    }}
                                    transition={{
                                        duration: 1,
                                        ease: "linear",
                                        repeat: Infinity,
                                        repeatType: "reverse",
                                    }}
                                    className="w-32 h-32 overflow-hidden rounded-lg"
                                >
                                    <Image src={'/games/apex-icon.webp'} width={200} height={200} alt='' />
                                </motion.div>
                                <motion.div
                                    animate={{
                                        rotate: isHovered ? 0 : [2, 0, -2],
                                        scale: isHovered ? 0.8 : [1.1, 1.2]
                                    }}
                                    transition={{
                                        duration: 1,
                                        ease: "linear",
                                        repeat: Infinity,
                                        repeatType: "reverse",
                                    }}
                                    className="w-32 h-32 overflow-hidden rounded-lg"
                                >
                                    <Image src={'/games/arena-icon.webp'} width={200} height={200} alt='' />
                                </motion.div>
                                <motion.div
                                    animate={{
                                        rotate: isHovered ? 0 : [4, 0, -4],
                                        scale: isHovered ? 0.8 : [1.1, 1.2]
                                    }}
                                    transition={{
                                        duration: 1,
                                        ease: "linear",
                                        repeat: Infinity,
                                        repeatType: "reverse",
                                    }}
                                    className="w-32 h-32 overflow-hidden rounded-lg"
                                >
                                    <Image src={'/games/band-band-icon.webp'} width={200} height={200} alt='' />
                                </motion.div>
                                <motion.div
                                    animate={{
                                        rotate: isHovered ? 0 : [-4, 0, 4],
                                        scale: isHovered ? 0.8 : [1.1, 1.2]
                                    }}
                                    transition={{
                                        duration: 1,
                                        ease: "linear",
                                        repeat: Infinity,
                                        repeatType: "reverse",
                                    }}
                                    className="w-32 h-32 overflow-hidden rounded-lg"
                                >
                                    <Image src={'/games/brawel-icon.webp'} width={200} height={200} alt='' />
                                </motion.div>
                                <motion.div
                                    animate={{
                                        rotate: isHovered ? 0 : [-2, 0, 2],
                                        scale: isHovered ? 0.8 : [1.1, 1.2]
                                    }}
                                    transition={{
                                        duration: 1,
                                        ease: "linear",
                                        repeat: Infinity,
                                        repeatType: "reverse",
                                    }}
                                    className="w-32 h-32 overflow-hidden rounded-lg"
                                >
                                    <Image src={'/games/coc-icon.webp'} width={200} height={200} alt='' />
                                </motion.div>
                                <motion.div
                                    animate={{
                                        rotate: isHovered ? 0 : [-4, 0, 4],
                                        scale: isHovered ? 0.8 : [1.1, 1.2]
                                    }}
                                    transition={{
                                        duration: 1,
                                        ease: "linear",
                                        repeat: Infinity,
                                        repeatType: "reverse",
                                    }}
                                    className="w-32 h-32 overflow-hidden rounded-lg"
                                >
                                    <Image src={'/games/cr-icon.webp'} width={200} height={200} alt='' />
                                </motion.div>
                            </div>
                            <div className='w-full h-full absolute flex justify-center items-center'>

                                <Button className={`w-[200px] h-[60px] z-20 ${isHovered && 'shadow-[0_0_50px_#843EEE]'} transition-shadow duration-300`}>همین الا شروع کن!</Button>
                            </div>
                        </div>
                    </div>
                </motion.div>
            </AnimationContainer>
        </div>
  );
};

export default BlurBox;